<template>
   <main id="event_body">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          이벤트 상세
        </h1>
      </div>
      <div class="div_padding"></div>
       <!-- 
         //[2]
         imported 된 컴포넌트들 사용
        -->
      <EventBannerForm :bannerImg="bannerImg"></EventBannerForm>
      <LottoEventForm :accountCoin="accountCoin"></LottoEventForm>
      <EventInfoForm :joinCnt="joinCnt" :eventTitle="eventTitle" :eventDesc="eventDesc" :eventGift="eventGift" :eventHowto="eventHowto"
                    :eventDate="eventDate" :winnerCondition="winnerCondition" :endTime="endTime" :eventWinnerOpenDateTime="eventWinnerOpenDateTime"></EventInfoForm>
    </div>
  </main>
</template>

<script>
/**
 * step. 1
 * 먼저 각각 파편화된 component 들을 import 해줍니다.
 * ex).
 * export defualt {
 *  componant: {
 *    <some imported component>,
 *    <some imported component>
 *  }
 * }
 * 
 * step. 2
 * imported 된 컴포넌트를 template tag 안에서
 * 자유롭게 해당 componant 명으로 자유롭게 사용 가능합니다.
 * @EventBannerForm = 상단 배너 componant
 * @LottoEventForm = 중단 로또 게임 componant
 * @EventInfoForm = 이벤트 정보 componant
 */
//[1]
import EventBannerForm from './common/EventBannerForm.vue'
import LottoEventForm from './common/LottoEventForm.vue'
import EventInfoForm from './common/EventInfoForm.vue'
import { fetchEventDetail } from '@/api/event'
export default {
  components: {
    EventBannerForm,
    LottoEventForm,
    EventInfoForm
  },
  created() {
    this.fetchData();
  },
  methods:{
    fetchData(){
      fetchEventDetail({
      nttId: this.$route.query.nttId
    })
    .then(({ data }) => {
      let result = data.result
      this.joinCnt = result.joinCnt
      this.eventTitle = result.eventTitle
      this.eventDesc = result.eventDesc
      this.eventGift = result.eventGift;
      this.eventHowto = result.eventHowto;
      this.eventDate = result.eventDate;
      this.eventWinnerOpenDateTime  = result.eventWinnerOpenDateTime;
      this.winnerCondition = result.winnerCondition;
      this.endTime = result.endTime
      this.bannerImg = result.eventImage
      this.accountCoin = result.accountCoinView

      var url = "/ongoingEvent";
      switch(result.status){
        case "ING":  url = "/ongoingEvent"; break;
        case "READY":{
          url = "/upcomingEvent";
          this.$router.replace({
            path: url,
            query: { nttId: result.nttId },
          });
          break;
        }
        case "END":{
          url = "/endedEvent";
          this.$router.replace({
            path: url,
            query: { nttId: result.nttId },
          });
          break;
        }
      }
    })
    .then(() => {
      try{
        var endTimestamp = new Date(this.endTime.replace(/-/g, "/")).getTime();
        var nowTimestamp = new Date().getTime();
        var time_diff =  Math.abs(endTimestamp - nowTimestamp);

        setTimeout(() => {
          this.$router.push({
            path: '/endedEvent', query: { nttId: this.$route.query.nttId}
          })
        }, time_diff) 
      }catch(e){
        console.log(e);
      }
    })
    }
  },
  data() {
    return {
      eventInfo: {},
      bannerImg:'',
      joinCnt: 0,
      eventTitle: '',
      eventDesc: '',
      eventGift: '',
      eventHowto: '',
      eventDate: '',
      eventWinnerOpenDateTime :'',
      winnerCondition: '',
      endTime: '',
      accountCoin: ''
    }
  },
}
</script>

<style>

</style>